
class exports.TraitPackage

    constructor: ->
        @id = null
        @trait_suppliers_id = null
        @name = ''
        @suffix = ''
        @description = ''
        @active = true

        # this should be calculated by the controller in the
        # recalculateActiveProducts() method
        @num_active = 0
